import { useIsCanceled } from './useIsCanceled';
import { useIsTrialer } from '../queries';
import { usePlanDetail } from '../queries/usePlanDetail';

export const useHasCharmPricing = () => {
  const { data, isLoading, error } = usePlanDetail();
  const { data: isTrialerData, isLoading: isTrialerLoading, error: isTrialerError } = useIsTrialer();
  const isCanceled = useIsCanceled();
  const isTrialer = !isTrialerLoading && !isTrialerError && !!isTrialerData;
  const isCharmPricing = !isLoading && !error && data?.isCharmPricing();
  const hasCharmPricing = !isCanceled && isTrialer && isCharmPricing;

  return Boolean(hasCharmPricing);
};

export type UseHasCharmPricing = ReturnType<typeof useHasCharmPricing>;
